import { render, staticRenderFns } from "./MediaLibraryItem.vue?vue&type=template&id=6ca71784&scoped=true&"
import script from "./MediaLibraryItem.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryItem.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryItem.vue?vue&type=style&index=0&id=6ca71784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca71784",
  null
  
)

export default component.exports